/* eslint-disable react/no-render-return-value */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './react/index';

/** The master component render outlet */
export const HeatingFormOutlet = (element: HTMLElement): void => {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		element,
	);
}
